/* eslint-disable import/no-unresolved */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable react/no-array-index-key */
/* eslint-disable no-undef */
/* eslint-disable react/prop-types */
import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { Badge, Box, Typography } from "@mui/material";
import FBNumber from "components/Elements/FBNumber";
import FBMonthYearPicker from "components/Elements/FBMonthYearPicker";
import FBComboBox from "components/Elements/FBComboBox";
import FBTextBox from "components/Elements/FBTextBox";
import FBRadioGroup from "components/Elements/FBRadioGroup";

import {
  transformInput,
  transformOutput,
  propNames,
} from "util/MultiArrestHelper";
import { idComplete } from "util/genericHelper";

const FBMultiArrestLanding = (props) => {
  const lblComplete = idComplete;
  const { id, required, value, tunnelToParent, options, label } = props;
  const {
    setValue: parentSetValue,
    setValueInReduxResponses,
    getValues,
  } = tunnelToParent;
  const crimeType = {
    Misdemeanor: "Misdemeanor",
    Felony: "Felony",
  };
  const crimeTypeOptions = [
    { label: crimeType.Misdemeanor, value: crimeType.Misdemeanor },
    { label: crimeType.Felony, value: crimeType.Felony }
  ];
  const yesNoOptions = [
    { label: "Yes", value: "Yes" },
    { label: "No", value: "No" }
  ];
  const {
    dropdown1Show,
    dropdown1Caption,
    dateShow,
    dateCaption,
    text1Show,
    text1Caption,
    text2Show,
    text2Caption,
    yesNo1Show,
    yesNo1Caption,
    dropdown2Show,
    dropdown2Caption,
    text3Show,
    text3Caption,
    date2Show,
    date2Caption,
    yesNo2Show,
    yesNo2Caption,
    text4Show,
    text4Caption,
    date3Show,
    date3Caption,
    yesNo3Show,
    yesNo3Caption,
    itemCaption,
  } = {
    dropdown1Show: true,
    dropdown1Caption: "Were you charged with a felony or misdemeanor?",
    dateShow: true,
    dateCaption: "When did this arrest occur?",
    text1Show: true,
    text1Caption: "What were you charged with?",
    text2Show: true,
    text2Caption: "What state and county were you arrested in?",
    yesNo1Show: true,
    yesNo1Caption: "Did the arrest result in a conviction?",
    dropdown2Show: true,
    dropdown2Caption: "Were you convicted of a felony or misdemeanor?",
    text3Show: true,
    text3Caption: "What was the conviction?",
    date2Show: true,
    date2Caption: "When did this conviction occur?",
    yesNo2Show: true,
    yesNo2Caption: "Were you incarcerated?",
    text4Show: true,
    text4Caption: "How much time was served?",
    date3Show: true,
    date3Caption: "When were you released?",
    yesNo3Show: true,
    yesNo3Caption: "Are charges still pending?",
    itemCaption: "Arrest",
    ...options,
  };

  const { control, watch, reset, setValue } = useForm({
    mode: "all",
  });

  const formValues = watch();

  const [numberOfTimes, setNumberOfTimes] = useState(null);
  const [canShowDrilldown1Yes, setCanShowDrilldown1Yes] = useState([]);
  const [canShowDrilldown1No, setCanShowDrilldown1No] = useState([]);
  const [canShowDrilldown2Yes, setCanShowDrilldown2Yes] = useState([]);

  const resetDrillDown2Questions = (index) => {
    const idPrefix = `${id}-${index}-`;
    setValue(`${idPrefix}${propNames.text4}`, "");
    setValue(`${idPrefix}${propNames.date3}`, null);
  };

  const resetDrillDown1Questions = (index) => {
    const idPrefix = `${id}-${index}-`;
    setValue(`${idPrefix}${propNames.dropdown2}`, "");
    setValue(`${idPrefix}${propNames.text3}`, "");
    setValue(`${idPrefix}${propNames.date2}`, null);
    setValue(`${idPrefix}${propNames.yesNo2}`, "");
    resetDrillDown2Questions(index);
  };

  const resetDrillDown1NoQuestions = (index) => {
    const idPrefix = `${id}-${index}-`;
    setValue(`${idPrefix}${propNames.yesNo3}`, "");
  };

  const enableDrilldown1Questions = (e, index) => {
    setCanShowDrilldown1Yes((prev) => {
      const updated = [...prev];
      updated[index] = e === "Yes";
      return updated;
    });
    setCanShowDrilldown1No((prev) => {
      const updated = [...prev];
      updated[index] = e === "No";
      return updated;
    });
    if (e !== "Yes") {
      resetDrillDown1Questions(index);
      setCanShowDrilldown2Yes((prev) => {
        const updated = [...prev];
        updated[index] = e === "Yes";
        return updated;
      });
    } else if (e !== "No") {
      resetDrillDown1NoQuestions(index);
    }
  };
  const enableDrilldown2Questions = (e, index) => {
    setCanShowDrilldown2Yes((prev) => {
      const updated = [...prev];
      updated[index] = e === "Yes";
      return updated;
    });
    if (e !== "Yes") {
      resetDrillDown2Questions(index);
    }
  };

  useEffect(() => {
    if (value) {
      const {
        numberOfTimes: lnumberOfTimes,
        responses,
      } = transformInput(id, value);
      const noOfTimes = parseInt(lnumberOfTimes, 10);
      // eslint-disable-next-line no-restricted-globals
      if (typeof noOfTimes === "number" && !isNaN(noOfTimes)) {
        setNumberOfTimes(noOfTimes);
        reset(responses);
      }
    }
  }, [id]);

  const transformAndUpdateParent = (lid, lnumberOfTimes, lformValues) => {
    const { transformedValue, isComplete } = transformOutput(
      lid,
      lnumberOfTimes,
      lformValues,
      options
    );

    const custTransValue = transformedValue === "[null]" ? undefined : transformedValue;
    if (parentSetValue) {
      parentSetValue(`${id}${lblComplete}`, isComplete);
      parentSetValue(id, custTransValue, {
        shouldDirty: true,
      });
    }
    if (setValueInReduxResponses) {
      setValueInReduxResponses(id, custTransValue, getValues);
    }
  };

  const numberOfTimesChangeHandler = (e) => {
    let lnoOfTimes = e === "" || e === undefined ? null : parseInt(e, 10);
    // Following condition always restricts the use to 10 items
    if (typeof lnoOfTimes === "number" && lnoOfTimes >= 10) lnoOfTimes = 10;
    setNumberOfTimes(lnoOfTimes);
    transformAndUpdateParent(id, lnoOfTimes, formValues);
  };

  const inputChangeHandler = (e, controlId) => {
    transformAndUpdateParent(id, numberOfTimes, {
      ...formValues,
      [controlId]: e,
    });
  };
  useEffect(() => {
    const initialDrilldown1YesVisibility = Array.from({ length: numberOfTimes }).map((_, index) => {
      return formValues[`${id}-${index}-${propNames.yesNo1}`] === "Yes";
    });
    const initialDrilldown1NoVisibility = Array.from({ length: numberOfTimes }).map((_, index) => {
      return formValues[`${id}-${index}-${propNames.yesNo1}`] === "No";
    });
    const initialDrilldown2YesVisibility = Array.from({ length: numberOfTimes }).map((_, index) => {
      return formValues[`${id}-${index}-${propNames.yesNo2}`] === "Yes";
    });
    setCanShowDrilldown1Yes(initialDrilldown1YesVisibility);
    setCanShowDrilldown1No(initialDrilldown1NoVisibility);
    setCanShowDrilldown2Yes(initialDrilldown2YesVisibility);
  }, [numberOfTimes]);

  const getDateInput = (index, propName, caption, canShow) => {
    const controlId = `${id}-${index}-${propName}`;
    if (!canShow) return false;
    return (
      <>
        <Typography color="text.secondary" variant="body2" gutterBottom>
          {caption}
        </Typography>
        <FBMonthYearPicker
          id={controlId}
          control={control}
          required={required}
          onChange={(e) => {
            inputChangeHandler(e, controlId);
          }}
          value={formValues[controlId]}
        />
        <br />
      </>
    );
  };

  const getTextInput = (index, propName, caption, canShow) => {
    if (!canShow) return false;
    return (
      <>
        <Typography color="text.secondary" variant="body2" gutterBottom>
          {caption}
        </Typography>
        <FBTextBox
          id={`${id}-${index}-${propName}`}
          control={control}
          required={required}
          onChange={(e) => {
            inputChangeHandler(e, `${id}-${index}-${propName}`);
          }}
          value={formValues[`${id}-${index}-${propName}`]}
        />
      </>
    );
  };

  const getDropdownInput = (index, propName, caption, canShow) => {
    const controlId = `${id}-${index}-${propName}`;
    if (!canShow) return false;
    return (
      <>
        <Typography color="text.secondary" variant="body2" gutterBottom>
          {caption}
        </Typography>
        <FBComboBox
          id={controlId}
          required={required}
          control={control}
          items={crimeTypeOptions}
          value={formValues[controlId]}
          disableClearable
          minWidth={250}
          onChange={(e) => {
            inputChangeHandler(e, controlId);
          }}
        />
      </>
    );
  };

  const getYesNo1Input = (index) => {
    if (!yesNo1Show) return false;
    return (
      <>
        <Typography sx={{ my: 1 }}>{yesNo1Caption}</Typography>
        <FBRadioGroup
          id={`${id}-${index}-${propNames.yesNo1}`}
          label={yesNo1Caption}
          control={control}
          items={yesNoOptions}
          value={formValues[`${id}-${index}-${propNames.yesNo1}`]}
          onChange={(e) => {
            inputChangeHandler(e, `${id}-${index}-${propNames.yesNo1}`);
            enableDrilldown1Questions(e, index);
          }}
        />
      </>
    );
  };

  const getYesNo2Input = (index) => {
    const controlId = `${id}-${index}-${propNames.yesNo2}`;
    if (!yesNo2Show) return false;
    return (
      <>
        <Typography sx={{ my: 1 }}>{yesNo2Caption}</Typography>
        <FBRadioGroup
          id={controlId}
          label={yesNo2Caption}
          control={control}
          items={yesNoOptions}
          value={formValues[controlId]}
          onChange={(e) => {
            inputChangeHandler(e, controlId);
            enableDrilldown2Questions(e, index);
          }}
        />
      </>
    );
  };

  const getYesNo3Input = (index) => {
    const controlId = `${id}-${index}-${propNames.yesNo3}`;
    if (!yesNo3Show) return false;
    return (
      <>
        <Typography sx={{ my: 1 }}>{yesNo3Caption}</Typography>
        <FBRadioGroup
          id={controlId}
          label={yesNo3Caption}
          control={control}
          items={yesNoOptions}
          value={formValues[controlId]}
          onChange={(e) => {
            inputChangeHandler(e, controlId);
          }}
        />
      </>
    );
  };

  const controlOrder = (index) => {
    return (
      <>
        {getDropdownInput(index, propNames.dropdown1, dropdown1Caption, dropdown1Show)}
        {getDateInput(index, propNames.date, dateCaption, dateShow)}
        {getTextInput(index, propNames.text1, text1Caption, text1Show)}
        {getTextInput(index, propNames.text2, text2Caption, text2Show)}
        {getYesNo1Input(index)}
      </>
    );
  };

  const drilldown1YesControls = (index) => {
    return (
      <>
        {getDropdownInput(index, propNames.dropdown2, dropdown2Caption, dropdown2Show)}
        {getTextInput(index, propNames.text3, text3Caption, text3Show)}
        {getDateInput(index, propNames.date2, date2Caption, date2Show)}
        {getYesNo2Input(index)}
      </>
    );
  };

  const drilldown1NoControls = (index) => {
    return (
      <>
        {getYesNo3Input(index)}
      </>
    );
  };

  const drilldown2YesControls = (index) => {
    return (
      <>
        {getTextInput(index, propNames.text4, text4Caption, text4Show)}
        {getDateInput(index, propNames.date3, date3Caption, date3Show)}
      </>
    );
  };

  return (
    <Box
      sx={{
        width: "fit-content",
        border: 1,
        padding: 1,
        borderColor: "lightslategrey",
        borderRadius: 2,
      }}
    >
      <Typography color="text.secondary" variant="body2" gutterBottom>
        {label}
      </Typography>
      <FBNumber
        id={`${id}-${propNames.numberOfTimes}`}
        required={required}
        control={control}
        onChange={numberOfTimesChangeHandler}
        value={numberOfTimes}
      />
      <br />
      {typeof numberOfTimes === "number" &&
                numberOfTimes > 0 &&
                [...Array(numberOfTimes)].map((el, index) => {
                  return (
                    <Box
                      key={`${id}-${index}`}
                      sx={{
                        marginTop: "10px",
                        width: "fit-content",
                        border: 1,
                        padding: 1,
                        borderColor: "lightslategrey",
                        borderRadius: 2,
                      }}
                    >
                      <Typography variant="subtitle1" gutterBottom>
                        <Badge>{`${itemCaption}-${index + 1}`}</Badge>
                      </Typography>
                      {controlOrder(index)}
                      {canShowDrilldown1Yes[index] && drilldown1YesControls(index)}
                      {canShowDrilldown1No[index] && drilldown1NoControls(index)}
                      {canShowDrilldown2Yes[index] && drilldown2YesControls(index)}
                    </Box>
                  );
                })}
    </Box>
  );
};

export default FBMultiArrestLanding;
